import React, {Component} from 'react';
import { Switch, Route, Link, Redirect, BrowserRouter as Router } from 'react-router-dom'
import '../CSS/Template.css'
import logo from '../images/logo2.png'
import LeftMenu from "../Components/LeftMenu.js"
import BooleanSwitch from "../Components/BooleanSwitch.js"
import AuthService from '../utils/AuthService.js';
import URLService from '../utils/URLService.js';
import Modal from 'react-modal';

export default class Header extends Component {
  constructor(props) {
    super(props)
    this.URLService = new URLService()
    var url = this.URLService.getUrl()
    this.state = {
      useBeta: false,
      url: url,
      modalIsOpen: false
    }
    this.Auth = new AuthService()
    this.checkUseBeta = this.checkUseBeta.bind(this)
  }
  checkUseBeta(useBeta) {
    this.setState({
      modalIsOpen:true
    })
  }
  switchToNewWeb() {
    this.Auth.switchVersions(false)
          .then(res =>{
            localStorage.removeItem('id_token')
            window.location.href = this.state.url + "customer/sign_out"
            //  this.props.history.replace('/');
          })
          .catch(err =>{
              alert(err);
          })
  }
  render() {
    const customStyles =
      this.state.width < 780 ?
      {
        content: {
          top                   : '0%',
          left                  : '0%',
          right                 : 'auto',
          bottom                : 'auto',
        }
      }:
        {
          content: {
            top                   : '50%',
            left                  : '50%',
            right                 : 'auto',
            bottom                : 'auto',
            transform             : 'translate(-50%, -50%)'
          }
        }
    return (
      <div>
        <nav className="navbar navbar-default">
          <div className="twoColumn">
            <LeftMenu />
            <a href="#" className="header-container"><img className='header-logo' src ={logo}></img></a>
          </div>
        </nav>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Components/Header.js